module.exports = __webpack_public_path__ + "img/Qualification_5.45f00a82.jpg";